import { render, staticRenderFns } from "./singleRedisc.vue?vue&type=template&id=16343b81"
import script from "./singleRedisc.vue?vue&type=script&lang=js"
export * from "./singleRedisc.vue?vue&type=script&lang=js"
import style0 from "./singleRedisc.vue?vue&type=style&index=0&id=16343b81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports